import * as React from 'react';
import { PasswordMeter as UIPasswordMeter } from '@gandi/ui';
import { jsx as _jsx } from "react/jsx-runtime";
const PasswordMeter = props => {
  const {
    error,
    isField,
    name,
    onBlur,
    onFocus,
    translator,
    ...extraProps
  } = props;
  return /*#__PURE__*/_jsx(UIPasswordMeter, {
    className: "form-control",
    handleBlur: onBlur,
    handleFocus: onFocus,
    name: name,
    translator: translator,
    ...extraProps
  });
};
export default PasswordMeter;